<template>
    <div class="filter-breadcrumb">
        <span class="item-breadcrumb" @click="openFilterByRef('yearPeriodRef')">
            {{ curYear.name }}
        </span>
        <template v-if="curRegion">
            <span class="item-breadcrumb" @click="openFilterByRef('regRef')">
                {{ curRegion.region }}-{{ getLocalizedName(curRegion) }}
            </span>
        </template>
        <template v-if="curBudgetType">
            <span class="item-breadcrumb" @click="openFilterByRef('dataTypeRef')">
                {{ getLocalizedName(curBudgetType) }}
            </span>
        </template>
        <template v-if="curBudgetVariant">
            <span class="item-breadcrumb" @click="openFilterByRef('versionRef')">
                {{ getLocalizedName(curBudgetVariant) }}
            </span>
        </template>
        <template v-if="curAbp">
            <span class="item-breadcrumb" @click="openFilterByRef('abpRef')">
                {{ curAbp.abp }}-{{ $t('modules.budget_execution_alteration.abp') }}
            </span>
        </template>
        <template v-if="curGu">
            <span class="item-breadcrumb" @click="openFilterByRef('guRef')">
                {{ curGu.gu }}-{{ $t('modules.budget_request.filter.gu') }}
            </span>
        </template>
        <template v-if="isGkkp">
            <span class="item-breadcrumb" @click="openFilterByRef('gkkpRef')">
                {{ curGkkp.gkkp }}-{{ $t('modules.budget_request.filter.gkkp') }}
            </span>
        </template>
        <template v-if="curPrg">
            <span class="item-breadcrumb">
                  {{ curPrg.prg }}-{{ getLocalizedName(curPrg) }}
            </span>
        </template>
    </div>
</template>
<script>
export default {
    name: 'CBreadCrumbs',
    props: {
        curYear: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curRegion: {
            type: Object,
            required: false
        },
        curAbp: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curGu: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        isGkkp: {
            type: Boolean,
            required: false,
        },
        curGkkp: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curBudgetType: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curBudgetVariant: {
            type: Object,
            required: false,
            default: () => {
            }
        },
        curPrg: {
            type: Object,
            required: false,
            default: () => {
            }
        }
    },
    mounted() {
    },
    data() {
        return {}
    },
    methods: {
        getLocalizedName(item) {
            const locale = this.$i18n.locale
            if (!item) return '';
            switch (locale) {
                case 'kk':
                    return item.nameKk || item.nameRu
                case 'en':
                    return item.nameEn || item.nameRu
                default:
                    return item.nameRu
            }
        },
        openFilterByRef(refName) {
            this.$emit('openFilterByRef', refName);
        }
    }
};

</script>
<style scoped>

</style>
